module.exports = __webpack_public_path__ + "img/logoPulse.8cc34e33.svg";